import React from 'react';
import PropTypes from 'prop-types';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';

const PackageMenuItem = ({ name, onChange, packageId, selectedPackageKey, itemClassName }) => {
  return (
    <DropdownMenuItem
      key={packageId}
      className={itemClassName}
      onClick={() => onChange(packageId)}
      selected={packageId === selectedPackageKey}
    >
      {name}
    </DropdownMenuItem>
  );
};

PackageMenuItem.propTypes = {
  name: PropTypes.string.isRequired,
  packageId: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  selectedPackageKey: PropTypes.string,
  className: PropTypes.string,
};

export default PackageMenuItem;
